;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import get from "lodash/get"
import {
  LOCATION_VIRTUAL,
  COHORT_LOCATION,
  COHORT_LOCATION_IN_PERSON_OR_VIRTUAL,
} from "../constants"

type CohortLike = {
  config?: Record<string, unknown>
}

type CohortInput = {
  cohort: CohortLike | null | undefined
}

export const inPersonOrRemote = ({ cohort }: CohortInput): string | null => {
  return get(
    cohort,
    `config[${COHORT_LOCATION}][${COHORT_LOCATION_IN_PERSON_OR_VIRTUAL}]`,
    null,
  )
}

export const isVirtual = ({ cohort }: CohortInput): boolean => {
  return inPersonOrRemote({ cohort }) === LOCATION_VIRTUAL
}
